import { ReactNode, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

interface TooltipProps {
  content: string;
  children: ReactNode;
  position?: 'top' | 'bottom';
}

export const Tooltip = ({
  content,
  children,
  position = 'bottom',
}: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const triggerRef = useRef<HTMLDivElement | null>(null);

  const updatePosition = () => {
    if (!triggerRef.current) return;

    const rect = triggerRef.current.getBoundingClientRect();
    const tooltipGap = 10;

    let top = 0;
    let left = rect.left + rect.width / 2;

    if (position === 'top') {
      top = rect.top - tooltipGap;
    } else {
      top = rect.bottom + tooltipGap;
    }

    setCoords({
      top,
      left,
    });
  };

  const handleMouseEnter = () => {
    updatePosition();
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  return (
    <>
      <div
        ref={triggerRef}
        className="inline-block"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>

      {isVisible &&
        createPortal(
          <div
            className="fixed z-[9999] pointer-events-none"
            style={{
              top: coords.top,
              left: coords.left,
              transform:
                position === 'top'
                  ? 'translate(-50%, calc(-100% - 2px))'
                  : 'translate(-50%, 0)',
            }}
          >
            <div className="relative px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm whitespace-nowrap">
              {content}

              <div
                className={`absolute w-2 h-2 bg-gray-900 transform rotate-45 left-1/2 -translate-x-1/2 ${
                  position === 'top' ? '-bottom-1' : '-top-1'
                }`}
              />
            </div>
          </div>,
          document.body
        )}
    </>
  );
};